import { z } from 'zod';

export type AccountMatch = z.infer<typeof AccountMatch>;
export const AccountMatch = z.object({
    type: z.string(),
    mealParticipantsExternal: z.boolean().nullish(),
});

const AccountMatchRaw = z.preprocess((input) => {
    if (typeof input === 'string') {
        return { type: input };
    }
    return input;
}, AccountMatch);

const AccountMatchInput = z.preprocess((input) => {
    if (!Array.isArray(input)) {
        return [input];
    }
    return input;
}, z.array(AccountMatchRaw));

export type AccountMapping = z.infer<typeof AccountMapping>;
export const AccountMapping = z.object({
    account: z.coerce.string(),
    accountId: z.number().nullish(),
    match: AccountMatchInput,
    catchAll: z.boolean().nullish(),
});
